import 'core-js';
import 'regenerator-runtime/runtime';

import { lazy } from 'react';

import coreFn from 'modules/core';
import { Loader } from 'modules/ui';

import theme from 'styles/theme';

import reducers from 'services/reducers';
import saga from 'services/saga';

import 'styles/index.css';

const Application = lazy(() => import('modules/application'));

const config = {
    redux: {
        reducers,
        saga,
        initialState: {},
        middlewares: [],
    },
    fela: {
        theme,
        staticCSS: [],
        fonts: [],
    },
    rootId: 'app',
};

const core = coreFn(config);
core.render(Application, Loader);
